import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0xB672Ea44A1EC692A9Baf851dC90a1Ee3DB25F1C4": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
  [
    "apostro",
    {
      name: "Apostro",
      logo: "entities/apostro.png",
      description:
        "Building a better way to self-regulate markets to avoid oracle attacks.",
      url: "https://www.apostro.xyz/",
      addresses: {
        "0x434D82854920664a02084d415936Dd7368C413f7": "Apostro Timelock",
        "0xf726311F85D45a7fECfFbC94bD8508a0A39958c6": "Apostro Multisig",
      },
      social: { twitter: "apostroxyz" },
    },
  ],
  [
    "tulipa-capital",
    {
      name: "Tulipa Capital",
      logo: "entities/tulipacapital.png",
      description:
        "At Tulipa Capital, we leverage cutting-edge technology and innovative financial strategies to maximize yields while implementing rigorous risk management practices.",
      url: "https://www.tulipa.capital/",
      addresses: {
        "0xF53eAeB7e6f15CBb6dB990eaf2A26702e1D986d8": "Tulipa Capital Multisig",
      },
      social: { twitter: "tulipacapital" },
    },
  ],
  [
    "k3-capital",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0x5Bb012482Fa43c44a29168C6393657130FDF0506":
          "K3 Capital Fireblocks Multisig",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0x3BA1566ED39F865bAf4c1Eb9acE53F3D2062bE65": "Re7 Labs Euler Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
])
